'use client';
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { avatarImg } from '@/lib/imgUrl';

export default function ReviewerAvatar({ src, name, size = 36 }: { src: string; name: string; size?: number }) {
  const [open, setOpen] = useState(false);
  const [failed, setFailed] = useState(false);   // photo file missing -> our Hebrew initial, never a broken image (root fix 15/10/26)
  const [zoomPx, setZoomPx] = useState(280);   // shrinks for small sources (120px reviewer PNGs) instead of a pixelated 280px blow-up
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  useEffect(() => {
    if (!open) return;
    function onKey(e: KeyboardEvent) { if (e.key === 'Escape') setOpen(false); }
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = prev; };
  }, [open]);

  if (failed) return (
    <span className="rounded-full flex items-center justify-center text-white font-bold flex-shrink-0" aria-hidden="true"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.46), background: `hsl(${((name || '?').charCodeAt(0) * 37) % 360},60%,42%)` }}>{(name || '?')[0] || '?'}</span>
  );
  return (
    <>
      <img onError={() => setFailed(true)} {...avatarImg(src, size)} alt={name} onClick={() => setOpen(true)} role="button" tabIndex={0} aria-label={`הגדלת התמונה של ${name}`} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpen(true); } }} referrerPolicy="no-referrer" loading="lazy" decoding="async"
        className="w-9 h-9 rounded-full object-cover flex-shrink-0"
        style={{ width: size, height: size, border: '1.5px solid #e2e8f0', cursor: 'zoom-in' }} />
      {open && mounted && createPortal(
        <div onClick={() => setOpen(false)}
          style={{ position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(0,0,0,.85)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, padding: 24, cursor: 'zoom-out' }}>
          <img {...avatarImg(src, 280)} alt={name} referrerPolicy="no-referrer" onClick={e => e.stopPropagation()}
            onLoad={e => setZoomPx(Math.max(120, Math.min(280, Math.round(e.currentTarget.naturalWidth * 1.5))))}
            style={{ width: `min(${zoomPx}px, 78vw)`, height: `min(${zoomPx}px, 78vw)`, borderRadius: '50%', objectFit: 'cover', border: '4px solid rgba(255,255,255,.9)', boxShadow: '0 10px 50px rgba(0,0,0,.5)' }} />
          <div style={{ color: '#fff', fontSize: 17, fontWeight: 700 }}>{name}</div>
        </div>,
        document.body
      )}
    </>
  );
}
